/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-08-15 16:30:01
 * @LastEditors: K
 * @LastEditTime: 2022-09-13 18:11:24
 */
import { ADMIN_API_PREFIX, API_PREFIX } from './constant'
import { Request } from './request'


// 广告列表
export interface advertisingListParams {
  size: number
  current : number
  platformType?: number
  status ?: number
}
export function advertisingList(params: advertisingListParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/m/sysadvertising/list`,
    method: "GET",
    params,
  };
}

// 保存广告页
export interface AdvertisingParams {
  imgUrl: string
  link: string
  platformType: number
  acceptTenant?: number
  // seq: number
  id?: string
  endTime?: string
  startTime?: string
  targetTenantId?: string[]
  labelIds?: string[]
}
export function advertising(body: AdvertisingParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/m/sysadvertising/save`,
    method: "POST",
    body,
  };
}
export function advertising2(body: AdvertisingParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/m/sysadvertising/savePopupAdvertising`,
    method: 'POST',
    body,
  }
}
// 列表-删除
export interface deleteListFnParams {
  id: string,
}
export function deleteListFn(params: deleteListFnParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/m/sysadvertising/remove`,
    method: "POST",
    params,
  };
}
// 列表-修改

export function updateListFn(body: AdvertisingParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/m/sysadvertising/update`,
    method: "POST",
    body,
  };
}
export function updateListFn2(body: AdvertisingParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/m/sysadvertising/updatePopupAdvertising`,
    method: "POST",
    body,
  };
}